<template>
  <app-side-menu>
    <aside class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">
          Filters
        </span>
      </p>
      <ul class="menu-list">
        <li>
          <div class="field">
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="innerValue.userType">
                  <option value="">All</option>
                  <option value="Users">User</option>
                  <option value="SupportUsers">Support User</option>
                </select>
              </div>
            </div>
          </div>
          <div class="buttons has-addons">
            <span class="button"
              :class="{ 'is-primary is-selected' : innerValue.active === null}"
              @click="changeActive(null)">
              <span class="icon is-small">
                <span class="mso mso-16px">
                  adjust
                </span>
              </span>
              <span>Both</span>
            </span>
            <span class="button"
              :class="{ 'is-success is-selected' : innerValue.active === 1}"
              @click="changeActive(1)">
              <span class="icon is-small">
                <span class="mso mso-20px">
                  check
                </span>
              </span>
              <span>Active</span>
            </span>
            <span class="button"
              :class="{ 'is-danger is-selected' : innerValue.active === 0}"
              @click="changeActive(0)">
              <span class="icon is-small">
                <span class="mso mso-20px">
                  close
                </span>
              </span>
              <span>In-Active</span>
            </span>
          </div>
        </li>
      </ul>
      <hr>
      <div class="field is-grouped is-pulled-right">
        <div class="control">
          <button class="button is-primary"
            @click="onFilterClick">
            <span class="icon">
              <span class="mso mso-18px">
                search
              </span>
            </span>
            <span>Filter</span>
          </button>
        </div>
        <div class="control">
          <button class="button"
            @click="onResetClick">
            <span class="icon">
              <span class="mso mso-18px">
                refresh
              </span>
            </span>
            <span>Reset</span>
          </button>
        </div>
      </div>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'UserListSideMenu',
  components: {
    AppSideMenu
  },
  props: {
    value: null
  },
  data() {
    return {
      innerValue: _cloneDeep(this.value)
    }
  },
  watch: {
    innerValue: {
      handler: function (newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  methods: {
    onFilterClick() {
      this.$emit('filter')
    },
    onResetClick() {
      this.$emit('reset')
    },
    changeActive(value) {
      this.innerValue.active = value
      this.onFilterClick()
    }
  }
}
</script>
